import React, { useState, useEffect, useContext } from 'react'
import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import StrengthIcon from '../../../../Assets/Images/STRENGTH.png';
import SoulIcon from '../../../../Assets/Images/SOUL.png';
import MindIcon from '../../../../Assets/Images/MIND.png'
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import './HeartStarterQuadrants.scss';
import StarterChart from '../../../Charts/StarterChart';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { initialData } from '../groupReport-pdf/QuadrantInFocus';
import StarterChartSelf from '../../../Charts/StarterChartSelf';
import { applyFullTieOrder, isFullTie, STARTER_CLOCKWISE } from '../../../../utils/quadrantTieOrder';

export default function HeartStarterQuadrants({ apiData, pageNumber, reportType }) {

  const [highestStarter, setHighestStarter] = useState('')
  const [variablsMapArray, setVariableMapArray] = useState()
  const [snapshotResult, setSnapshotResults] = useState([]);
  const [starterLabel, setStarterLabel] = useState([]);
  const [highestScoredVariable, setHighestScoredVariable] = useState('');
  const groupReportCtx = useContext(GroupReportContext);
  const [dynamicData, setDynamicData] = useState([...initialData]);
  const [top3, setTop3] = useState();
  const [allResultsState, setAllResultsState] = useState([]);

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const displayData = dynamicData?.filter((el) => el.quadrant === highestStarter?.toUpperCase());
  const allVariableSets = [apiData?.variables];

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  };

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});

  const getMostScoredLabel = () => {
    if (highestStarter?.includes("heart")) return "HEART";
    if (highestStarter?.includes("soul")) return "SOUL";
    if (highestStarter?.includes("mind")) return "MIND";
    if (highestStarter?.includes("str")) return "STRENGTH";
    return "";
  };

  useEffect(() => {
    if (!highestStarter || !groupReportCtx) return;

    const quadrantKey = quadrantScores[highestStarter.toUpperCase()];
    const tempResults = [];

    displayData?.forEach((el, index) => {
      const res = groupReportCtx?.calculateQuestionScore(
        quadrantKey,
        allVariableSets,
        index + 1,
        "in_focus"
      );

      if (res?.averageScore !== null && quadrantKey === quadrantScores[el.quadrant]) {
        tempResults.push({
          ...res,
          question: el.question
        });
      }
    });

    setAllResultsState(tempResults);
  }, [highestStarter, groupReportCtx, apiData]);

  const getTop3Questions = () => {
    const sortedAllResults = [...allResultsState]
      ?.sort((a, b) => b.averageScore - a.averageScore)
      ?.filter((el) => el.averageScore >= 0);

    return sortedAllResults?.slice(0, 3);
  };
  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
  }, [apiData]);

  useEffect(() => {
    const avgPercentagesSelf = groupReportCtx?.averagePercentagesSelf?.map((el) => el?.avg);
    const avgPercentagesSelfLabel = ['mind', 'soul', 'strength', 'heart'];
    const selfStarters = groupReportCtx?.averagePercentagesSelf;
    // 4-way tie: first quadrant in clockwise order (Strength) wins
    const maxAvgObj = isFullTie(avgPercentagesSelf)
      ? applyFullTieOrder(selfStarters, (el) => el?.name, (el) => el?.avg)[0]
      : selfStarters?.reduce((max, current) => {
        return current.avg > max.avg ? current : max;
      });

    setHighestStarter(maxAvgObj?.name?.toLowerCase());
    setSnapshotResults(avgPercentagesSelf);
    setStarterLabel(avgPercentagesSelfLabel);
    setHighestScoredVariable(maxAvgObj?.name?.toLowerCase());
  }, [apiData, variablsMapArray, groupReportCtx]);

  useEffect(() => {
    const top3Questions = getTop3Questions();
    setTop3(top3Questions);
  }, [allResultsState]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      // console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;

      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;

      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;

      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);


      // console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{ "name": "heart", "score": heart_highest }, { "name": "soul", "score": soul_highest }, { "name": "mind", "score": mind_highest }, { "name": "strength", "score": strength_highest }];
      // console.log("testingVarsM2Pair",testingVarsM2Pair);

      highestVariable = testingVarsM2Pair.reduce((max, current) =>
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );


      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m)
      let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2
      let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l)
      let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2

      // console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1)
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100

      // console.log("scores-",most_score,second_most_score,least_score,second_least_score)
      // console.log("scores-per",most_per,second_most_per,least_score,second_least_per)


      let labels = testingVarsM2Pair.map(item => item.name);

      const labels_arr = ["heart", "soul", "mind", "strength"];

      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      // console.log(most_label , 'most_label')
      const getPercentageOrder = (label) => {
        if (label == most_label?.toLowerCase()) {
          return most_per;
        }
        if (label == second_most_label?.toLowerCase()) {
          return second_most_per;
        }
        if (label == least_label?.toLowerCase()) {
          return least_per;
        }
        if (label == second_least_label?.toLowerCase()) {
          return second_least_per;
        }

        return 0
      }

      // console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
      // console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)

      // order should be most > second most > least > second least
      // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'

      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['mind', 'soul', 'strength', 'heart'];

      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);

      // 4-way tie on round 1 'most' counts: clockwise order picks Strength
      setHighestStarter(isFullTie(mostValues) ? STARTER_CLOCKWISE[0] : most_label);
      // setStarterScore(most_per);
      // setSnapshotResults(results);
      // setStarterLabel(labelsArray);
      // getMostAndSecondMostVaribale(apiData)

    }

  }, [variablsMapArray]);

  const getStarterHeading = () => {
    if (highestStarter?.includes("heart")) return "HEART STARTER";
    if (highestStarter?.includes("str")) return "STRENGTH STARTER";
    if (highestStarter?.includes("soul")) return "SOUL STARTER";
    if (highestStarter?.includes("mind")) return "MIND STARTER";
    else return "NONE";
  }
  const getStarterSections = () => {
    if (highestStarter?.includes("heart")) return "Heart";
    if (highestStarter?.includes("str")) return "Strength";
    if (highestStarter?.includes("soul")) return "Soul";
    if (highestStarter?.includes("mind")) return "Mind";
    else return "";
  }

  const getStarterLogo = () => {
    if (highestStarter?.includes("heart")) return HeartIcon;
    if (highestStarter?.includes("str")) return StrengthIcon;
    if (highestStarter?.includes("soul")) return SoulIcon;
    if (highestStarter?.includes("mind")) return MindIcon;
    else return "NONE";
  }

  const HighestStarterInfo = () => {
    if (highestStarter?.includes("heart")) return "Heart Starters are connection-oriented people who lead with feelings, wants, passion, or desire. They are the lovers, encouragers, connectors, culture carriers, and relational catalysts who bring people together. They are motivated by belonging, which draws them into deeper relationships with themselves and others. Their “Capacity for Connection” is the lens through which everything passes."
    if (highestStarter?.includes("str")) return "Strength Starters are action-oriented people who bring energy as doers, drivers, and builders. They are the warriors, operators, executors, competitors, and mobilizers who move things forward. They are motivated by momentum, practicalities, and results. Their “Capacity for Service” drives them to carry weight for something bigger than themselves."
    if (highestStarter?.includes("soul")) return "Soul Starters are meaning-oriented people who offer wisdom, perspective, and creativity. They are the sages, storytellers, inventors, creators, and big-picture thinkers who look for what matters most. They are driven by story, symbolism, and purpose and consistently return to the deeper “why.” Their “Capacity for Meaning” shapes the way they connect, communicate, and move through the world."
    if (highestStarter?.includes("mind")) return "Mind Starters are logic-oriented people grounded in structure, strategy, and planning. They are the strategists, the thinkers, engineers, designers, and planners who bring order to complexity and spend much of their energy in thoughtful analysis. They are motivated by learning, understanding, and clarity. Their “Capacity for Understanding” shapes how they lead and decide."
    else return ""
  }

  const StarterInfo2 = () => {
    if (highestStarter?.includes("heart")) return "“Capacity for Connection” is their fundamental point for action."
    if (highestStarter?.includes("str")) return "They steward a “Capacity for Service” to something greater than themselves."
    if (highestStarter?.includes("soul")) return " “Capacity for Meaning” is their context for everything else."
    if (highestStarter?.includes("mind")) return "“Capacity for Understanding” the big picture is a necessity."
    else return "";
  }

  const QueOne = () => {
    if (highestStarter?.includes("heart")) return "How does this make me feel?"
    if (highestStarter?.includes("str")) return "How do I win?"
    if (highestStarter?.includes("soul")) return "Why are we doing this?"
    if (highestStarter?.includes("mind")) return "Does this make sense to me?"
    else return "";
  }
  const QueTwo = () => {
    if (highestStarter?.includes("heart")) return "Who needs my help?"
    if (highestStarter?.includes("str")) return "What needs to be done?"
    if (highestStarter?.includes("soul")) return "What's the deeper purpose here?"
    if (highestStarter?.includes("mind")) return "What do we need to know?"
    else return "";
  }
  const QueThree = () => {
    if (highestStarter?.includes("heart")) return "What do I need to stay connected?"
    if (highestStarter?.includes("str")) return "When can I get started?"
    if (highestStarter?.includes("soul")) return "Does this feel true to who I am?"
    if (highestStarter?.includes("mind")) return "What steps come next?"
    else return "";
  }

  const QueFour = () => {
    if (highestStarter?.includes("heart")) return null;
    if (highestStarter?.includes("str")) return null;
    if (highestStarter?.includes("soul")) return null
    if (highestStarter?.includes("mind")) return null;
    else return "";
  }

  const StrengthsSection = () => {
    if (highestStarter?.includes("heart")) return [
      { title: "Strong Connector", desc: "Build trust and rapport quickly." },
      { title: "Team Builder", desc: "Create a sense of belonging." },
      { title: "Empathy Radar", desc: "Read emotions accurately." },
      { title: "Culture Lifter", desc: "Improve team morale and cohesion." },
      { title: "Warm Communicator", desc: "Make people feel seen and valued." },
      { title: "People-Pleasing", desc: "Put others’ needs above your own mission." },
      { title: "Emotion Overload", desc: "Get overwhelmed by strong feelings." },
      { title: "Slow to Act", desc: "Reflect too long before moving forward." },
      { title: "Over-Carrying", desc: "Take on others’ emotional weight." },
      { title: "Easily Wounded", desc: "Feel hurt when relationships shift." },
    ];
    if (highestStarter?.includes("str")) return [
      { title: "Fast Executor", desc: "Turn ideas into action quickly." },
      { title: "Decisive Leader", desc: "Make quick, confident calls." },
      { title: "Results Driver", desc: "Push work to the finish line." },
      { title: "Resource Hunter", desc: "Get what the team needs to win." },
      { title: "High Ownership", desc: "Take responsibility for the mission." },
      { title: "Over-Driving", desc: "Push too hard or too fast." },
      { title: "Impulsive Action", desc: "Move before the plan is clear." },
      { title: "Relational Gaps", desc: "Miss emotional cues in people." },
      { title: "Takeover Tendencies", desc: "Do the work instead of delegating." },
      { title: "Burnout Risk", desc: "Carry more weight than is healthy." },
    ];
    if (highestStarter?.includes("soul")) return [
      { title: "Big-Picture Thinker", desc: "See long-term purpose and direction." },
      { title: "Creative Framer", desc: "Use stories and ideas to inspire others." },
      { title: "Wise Counselor", desc: "Offer insight during uncertainty." },
      { title: "Perspective Shifter", desc: "Help teams see new angles." },
      { title: "Vision Driver", desc: "Keep focus on mission and meaning." },
      { title: "Idea Island", desc: "Withdraw into thinking instead of acting." },
      { title: "Follow-Through Gaps", desc: "Struggle with details and routine tasks." },
      { title: "Idealism Drift", desc: "Expect standards that are hard to execute." },
      { title: "Avoiding Tension", desc: "Pull back from conflict or hard conversations." },
      { title: "Feeling Misunderstood", desc: "Retreat when insight isn’t recognized." },
    ];
    if (highestStarter?.includes("mind")) return [
      { title: "Clear Planner", desc: "Build structure, systems, and order." },
      { title: "Problem Solver", desc: "Break complex issues into steps." },
      { title: "Logical Thinker", desc: "Make steady, informed decisions." },
      { title: "Consistent Communicator", desc: "Provide clarity and direction." },
      { title: "Calm Under Pressure", desc: "Stay steady when things intensify." },
      { title: "Analysis Paralysis", desc: "Slow decisions while gathering more data." },
      { title: "Low Empathy Signals", desc: "Seem distant or critical." },
      { title: "Rigid Processes", desc: "Hold too tightly to one approach." },
      { title: "Detail Dumping", desc: "Overwhelm others with information." },
      { title: "Relational Blind Spots", desc: "Miss interpersonal dynamics." },
    ];
    else return "";
  }

  const ChallengesSection = () => {
    if (highestStarter?.includes("heart")) return null;
    if (highestStarter?.includes("str")) return null;
    if (highestStarter?.includes("soul")) return "Soul Starters may isolate themselves in the world of ideas, withdraw when they feel invalidated or misunderstood, or seek safety in exploration without choosing to act. Their natural insight can sometimes lead to pride or elitism, and they may become overly idealistic. They may avoid relationships that require a lot of work or create unnecessary anxiety and tension. Driven by vision, they often struggle with details and routine tasks, finding them challenging to follow through on."
    if (highestStarter?.includes("mind")) return null;
    else return "";
  }

  const combinedList = () => {
    if (!(highestStarter?.includes("str") || highestStarter?.includes("mind") || highestStarter?.includes("soul") || highestStarter?.includes("heart"))) return null;
    const items = StrengthsSection();
    if (!Array.isArray(items)) return null;
    return items;
  };

  return (
    <div className='self-report-result'>
      <HeaderPreview apiData={apiData} />
      <div className="heart-starter-wrapper">
        <div className="heart-starter-container">
          <h2 className="heart-starter-title">
            YOU TESTED AS A {getStarterHeading()}
          </h2>

          <div className="heart-starter-content">
            <div className="heart-icon">
              <img src={getStarterLogo()} alt="Heart Icon" />
            </div>

            <div className="heart-description">
              {HighestStarterInfo()}
              {/* <br />
              {StarterInfo2()} */}
            </div>
          </div>

          <div className="heart-starter-details">
            <div className="">
              <h5 className="questions-title">{getStarterSections()} Starters often ask:</h5>
              <ol className="questions-list">
                {[QueOne(), QueTwo(), QueThree()].filter(Boolean).map((q, idx) => (
                  <li key={idx}>{q}</li>
                ))}
              </ol>
            </div>

            <div className="strengths-challenges">
              <h5 className="section-title">Likely Strengths &amp; Potential Challenges</h5>
              {combinedList() ? (
                <ol className="section-list" >
                  {combinedList()?.map((item, idx) => (
                    <li key={idx}>
                      <input type='checkbox' disabled />
                      <strong>{item.title}</strong> &ndash; {item.desc}
                    </li>
                  ))}
                </ol>
              ) : (
                <ol className="section-list">
                  {StrengthsSection() && (
                    <li>
                      <strong>Strengths:</strong> {StrengthsSection()}
                    </li>
                  )}
                  {ChallengesSection() && (
                    <li>
                      <strong>Challenges:</strong> {ChallengesSection()}
                    </li>
                  )}
                </ol>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px', width: '100%' }}>
          <div style={{  transform: 'translateX(-50px)', flex: '0 0 200px', maxWidth: '300px', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'visible' }}>
            <StarterChartSelf
              originalData={snapshotResult}
              labels={starterLabel}
              ch='mind'
            />
          </div>
          <div style={{ flex: '1 1 0', display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column", transform: 'translateX(-70px)', minWidth: '242px' }}>
            <h4 style={{ fontSize: '11px', lineHeight: '15px', fontWeight: 700, fontFamily: 'Helvetica,  sans-serif', color: '#000000', margin: 0, letterSpacing: '0px', textTransform: 'uppercase' }}>
              STRONGEST CONFIRMATIONS AS A {getMostScoredLabel()}-STARTER
            </h4>
            <ol style={{ margin: 0, padding: 0, marginLeft: "10px" }}>
              {top3?.length === 0 ? (
                <li style={{ fontSize: '10px', lineHeight: '14px', fontWeight: 400, fontFamily: "Helvetica,  sans-serif", color: '#000000', letterSpacing: '0px' }}>No data available.</li>
              ) : (
                top3?.map((q, idx) => (
                  <li key={q.id ?? idx} style={{ fontSize: '10px', lineHeight: '14px', fontWeight: 400, fontFamily: "Helvetica,  sans-serif", color: '#000000', letterSpacing: '0px' }}>{q.question}</li>
                ))
              )}
            </ol>
          </div>
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  )
}
